// NavBar.tsx
import React from "react";
import NavBarDesktop from "./NbDesktop";
import NavBarMobile from "./NbMobile";

export default function NavBar({ states }) {
  return (
    <>
      <div className="d-none d-md-none d-lg-block">
        <NavBarDesktop {...states}/>
      </div>
      <div className="d-block d-md-block d-lg-none">
        <NavBarMobile {...states}  />
      </div>
    </>
  );
}
